import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setWidgetChartType,
  setY_attribute,
} from "../../../../redux/actions/WidgetMaker/GraphConfig";
import "./ChartType.css";
import barLineChart from "../../../../assets/WidgetMaker/bar-line-chart.svg";
import barChart from "../../../../assets/WidgetMaker/bar-chart.svg";
import horizontalBarChart from "../../../../assets/WidgetMaker/horizontal-bar-chart.svg";
import areaChart from "../../../../assets/WidgetMaker/area-chart.svg";
import lineChart from "../../../../assets/WidgetMaker/line-chart.svg";
import pieChart from "../../../../assets/WidgetMaker/pie-chart.svg";
import doughnutChart from "../../../../assets/WidgetMaker/doughnut-chart.svg";
import gridChart from "../../../../assets/WidgetMaker/grid-chart.svg";
import bubbleChart from "../../../../assets/WidgetMaker/bubble-chart.svg";
import wordCloudChart from "../../../../assets/WidgetMaker/word-cloud-chart.svg";
import numberChart from "../../../../assets/WidgetMaker/number-chart.svg";
import mapChart from "../../../../assets/WidgetMaker/map-chart.svg";
import heatmapChart from "../../../../assets/WidgetMaker/heatmap-chart.svg";
import sunburstChart from "../../../../assets/WidgetMaker/sunburst-chart.svg";
import authorChart from "../../../../assets/WidgetMaker/Profile_Card_Black.svg";
import authorChartBlue from "../../../../assets/WidgetMaker/Profile_Card_Blue.svg";
import barLineChartBlue from "../../../../assets/WidgetMaker/bar-line-chart-blue.svg";
import barChartBlue from "../../../../assets/WidgetMaker/bar-chart-blue.svg";
import horizontalBarChartBlue from "../../../../assets/WidgetMaker/horizontal-bar-chart-blue.svg";
import lineChartBlue from "../../../../assets/WidgetMaker/line-chart-blue.svg";
import pieChartBlue from "../../../../assets/WidgetMaker/pie-chart-blue.svg";
import doughnutChartBlue from "../../../../assets/WidgetMaker/doughnut-chart-blue.svg";
import gridChartBlue from "../../../../assets/WidgetMaker/grid-chart-blue.svg";
import areaChartBlue from "../../../../assets/WidgetMaker/area-chart-blue.svg";
import bubbleChartBlue from "../../../../assets/WidgetMaker/bubble-chart-blue.svg";
import wordCloudChartBlue from "../../../../assets/WidgetMaker/word-cloud-chart-blue.svg";
import numberChartBlue from "../../../../assets/WidgetMaker/number-chart-blue.svg";
import mapChartBlue from "../../../../assets/WidgetMaker/map-chart-blue.svg";
import heatmapChartBlue from "../../../../assets/WidgetMaker/heatmap-chart-blue.svg";
import sunburstChartBlue from "../../../../assets/WidgetMaker/sunburst-chart-blue.svg";
import postCard from "../../../../assets/WidgetMaker/Post_card.svg";
import postCardBlue from "../../../../assets/WidgetMaker/Post_card_blue.svg";
import News_card_icon from "../../../../assets/WidgetMaker/News_card_icon.svg";
import News_card_blue_icon from "../../../../assets/WidgetMaker/News_card_blue_icon.svg";
import News_card_icon_white from "../../../../assets/WidgetMaker/News_card_icon_white.svg";
import surveyCard from "../../../../assets/WidgetMaker/Survey_card.svg";
import surveyCardBlue from "../../../../assets/WidgetMaker/Survey_card_Blue.svg";
import surveyCardWhite from "../../../../assets/WidgetMaker/Survey_card_white.svg";
import pivot_blue from "../../../../assets/WidgetMaker/pivot_blue.svg";
import prolificUsers from "../../../../assets/WidgetMaker/Prolific_Users.svg";
import prolificUsers_blue from "../../../../assets/WidgetMaker/Prolific_Users_Blue.svg";
import RatingCardGray from "../../../../assets/WidgetLibrary/Rating_Card_gray.svg";
import RatingCardBlue from "../../../../assets/WidgetLibrary/Rating_Card_icon-blue.svg";
import Lollipop from "../../../../assets/WidgetMaker/Lollypop.svg";
import authorChartwhite from "../../../../assets/WidgetMaker/Profile_Card_white.svg";
import postCardwhite from "../../../../assets/WidgetMaker/Post_card_white.svg";
import RatingCardwhite from "../../../../assets/WidgetLibrary/Rating_Card_icon-white.svg";
import prolificUsers_white from "../../../../assets/WidgetMaker/Prolific_Users_white.svg";
import pivot_white from "../../../../assets/WidgetMaker/pivot_white.svg";
import barLineChartwhite from "../../../../assets/WidgetMaker/bar-line-chart-white.svg";
import barChartwhite from "../../../../assets/WidgetMaker/bar-chart-white.svg";
import horizontalBarChartwhite from "../../../../assets/WidgetMaker/horizontal-bar-chart-white.svg";
import lineChartwhite from "../../../../assets/WidgetMaker/line-chart-white.svg";
import pieChartwhite from "../../../../assets/WidgetMaker/pie-chart-white.svg";
import doughnutChartwhite from "../../../../assets/WidgetMaker/doughnut-chart-white.svg";
import gridChartwhite from "../../../../assets/WidgetMaker/grid-chart-white.svg";
import areaChartwhite from "../../../../assets/WidgetMaker/area-chart-white.svg";
import bubbleChartwhite from "../../../../assets/WidgetMaker/bubble-chart-white.svg";
import wordCloudChartwhite from "../../../../assets/WidgetMaker/word-cloud-chart-white.svg";
import numberChartwhite from "../../../../assets/WidgetMaker/number-chart-white.svg";
import mapChartwhite from "../../../../assets/WidgetMaker/map-chart-white.svg";
import heatmapChartwhite from "../../../../assets/WidgetMaker/heatmap-chart-white.svg";
import sunburstChartwhite from "../../../../assets/WidgetMaker/sunburst-chart-white.svg";
import progresKpiBlue from "../../../../assets/WidgetMaker/Circular_KPI_Active.svg";
import progresKpiWhite from "../../../../assets/WidgetMaker/Circular_KPI_Inactive.svg";
import progressKpiIcon from "../../../../assets/WidgetMaker/circular-kpi.svg";
import sankeyBlue from "../../../../assets/WidgetMaker/sankeyBlue.svg";
import sankeyWhite from "../../../../assets/WidgetMaker/sankeyWhite.svg";
import pivot from "../../../../assets/WidgetMaker/pivot.svg";
import networkGraph from "../../../../assets/WidgetMaker/NetworkGraph.svg";
import networkGraphBlue from "../../../../assets/WidgetMaker/NetworkGraphBlue.svg";
import networkGraphWhite from "../../../../assets/WidgetMaker/NetworkGraphWhite.svg";

import scatterChartBlue from "../../../../assets/WidgetMaker/scatter-chart-blue.svg";
import scatterChartWhite from "../../../../assets/WidgetMaker/scatter-chart-white.svg";
import scatterChartIcon from "../../../../assets/WidgetMaker/scatter-chart.svg";

import quadrantChartBlue from "../../../../assets/WidgetMaker/Quadrant-chart-blue.svg";
import quadrantChartWhite from "../../../../assets/WidgetMaker/Quadrant-chart-white.svg";
import quadrantChartIcon from "../../../../assets/WidgetMaker/Quadrant-chart.svg";

import mlMapChartBlue from "../../../../assets/WidgetMaker/ml-map-chart-blue.svg";
import mlMapChartWhite from "../../../../assets/WidgetMaker/ml-map-chart-white.svg";
import mlMapChartIcon from "../../../../assets/WidgetMaker/ml-map-chart.svg";

import { Tooltip } from "antd";
import { getFilterPanelData } from "../../../../redux/constants";
import { setFilterPanelData } from "../../../../redux/actions/Filter";
import richTextChart from "../../../../assets/WidgetMaker/rich-text-chart.svg";
import richTextChartBlue from "../../../../assets/WidgetMaker/rich-text-chart-blue.svg";
import richTextChartWhite from "../../../../assets/WidgetMaker/rich-text-chart-white.svg";
import { chart } from "highcharts";
import { getChartAttributesFieldConfigAPI } from "../../../../redux/actions/WidgetMaker/WidgetAPI";

import treemapChartIcon from "../../../../assets/WidgetMaker/tree-map-chart.svg";
import treemapChartBlue from "../../../../assets/WidgetMaker/tree-map-chart-blue.svg";
import treemapChartWhite from "../../../../assets/WidgetMaker/tree-map-chart-white.svg";

import clusterChartBlue from "../../../../assets/WidgetMaker/cluster-chart-blue.svg";
import clusterChartWhite from "../../../../assets/WidgetMaker/cluster-chart-white.svg";
import clusterChartIcon from "../../../../assets/WidgetMaker/cluster-chart.svg";
import { setChartAttributesFieldConfig } from "../../../../redux/actions/WidgetMaker/WidgetMaker";

const chartType = [
  {
    id: 1,
    name: "combination",
    icon: barLineChart,
    blueIcon: barLineChartBlue,
    whiteIcon: barLineChartwhite,
  },
  {
    id: 2,
    name: "bar",
    icon: barChart,
    blueIcon: barChartBlue,
    whiteIcon: barChartwhite,
  },
  {
    id: 3,
    name: "horizontal-bar",
    icon: horizontalBarChart,
    blueIcon: horizontalBarChartBlue,
    whiteIcon: horizontalBarChartwhite,
  },
  {
    id: 4,
    name: "area",
    icon: areaChart,
    blueIcon: areaChartBlue,
    whiteIcon: areaChartwhite,
  },
  {
    id: 5,
    name: "line",
    icon: lineChart,
    blueIcon: lineChartBlue,
    whiteIcon: lineChartwhite,
  },
  {
    id: 6,
    name: "pie",
    icon: pieChart,
    blueIcon: pieChartBlue,
    whiteIcon: pieChartwhite,
  },
  {
    id: 7,
    name: "donut",
    icon: doughnutChart,
    blueIcon: doughnutChartBlue,
    whiteIcon: doughnutChartwhite,
  },
  {
    id: 8,
    name: "grid",
    icon: gridChart,
    blueIcon: gridChartBlue,
    whiteIcon: gridChartwhite,
  },
  {
    id: 16,
    name: "pivot-grid",
    icon: pivot,
    blueIcon: pivot_blue,
    whiteIcon: pivot_white,
  },
  {
    id: 9,
    name: "bubble",
    icon: bubbleChart,
    blueIcon: bubbleChartBlue,
    whiteIcon: bubbleChartwhite,
  },
  {
    id: 13,
    name: "heatmap",
    icon: heatmapChart,
    blueIcon: heatmapChartBlue,
    whiteIcon: heatmapChartwhite,
  },
  {
    id: 14,
    name: "sunburst",
    icon: sunburstChart,
    blueIcon: sunburstChartBlue,
    whiteIcon: sunburstChartwhite,
  },
  {
    id: 10,
    name: "wordcloud",
    icon: wordCloudChart,
    blueIcon: wordCloudChartBlue,
    whiteIcon: wordCloudChartwhite,
  },
  {
    id: 11,
    name: "kpi",
    icon: numberChart,
    blueIcon: numberChartBlue,
    whiteIcon: numberChartwhite,
  },

  {
    id: 15,
    name: "post-card",
    icon: postCard,
    blueIcon: postCardBlue,
    whiteIcon: postCardwhite,
  },
  {
    id: 17,
    name: "prolific-user",
    icon: prolificUsers,
    blueIcon: prolificUsers_blue,
    whiteIcon: prolificUsers_white,
  },
  {
    id: 18,
    name: "review-card",
    icon: RatingCardGray,
    blueIcon: RatingCardBlue,
    whiteIcon: RatingCardwhite,
  },
  {
    id: 12,
    name: "map",
    icon: mapChart,
    blueIcon: mapChartBlue,
    whiteIcon: mapChartwhite,
  },
  {
    id: 19,
    name: "author-card",
    icon: authorChart,
    blueIcon: authorChartBlue,
    whiteIcon: authorChartwhite,
  },
  // {
  //   id: 20,
  //   name: "progress-kpi",
  //   icon: progresKpiWhite,
  //   blueIcon: progresKpiBlue,
  //   whiteIcon: progressKpiIcon,
  // },
  {
    id: 21,
    name: "lollipop",
    icon: Lollipop,
    blueIcon: Lollipop,
    whiteIcon: Lollipop,
  },
  // {
  //   id: 20,
  //   name: "progress-kpi",
  //   icon: progresKpiWhite,
  //   blueIcon: progresKpiBlue,
  //   whiteIcon: progressKpiIcon,
  // },
  {
    id: 22,
    name: "survey-card",
    icon: surveyCard,
    blueIcon: surveyCardBlue,
    whiteIcon: surveyCardWhite,
  },
  {
    id: 23,
    name: "sankey",
    icon: sankeyWhite,
    blueIcon: sankeyBlue,
    whiteIcon: sankeyWhite,
  },
  {
    id: 24,
    name: "news-card",
    icon: News_card_icon,
    blueIcon: News_card_blue_icon,
    whiteIcon: News_card_icon_white,
  },
  {
    id: 25,
    name: "scatter",
    icon: scatterChartIcon,
    blueIcon: scatterChartBlue,
    whiteIcon: scatterChartWhite,
  },
  // {
  //   id: 26,
  //   name: "quadrant",
  //   icon: quadrantChartIcon,
  //   blueIcon: quadrantChartBlue,
  //   whiteIcon: quadrantChartWhite,
  // },
  {
    id: 28,
    name: "multilayer-map",
    icon: mlMapChartIcon,
    blueIcon: mlMapChartBlue,
    whiteIcon: mlMapChartWhite,
  },
  {
    id: 29,
    name: "rich-text",
    icon: richTextChart,
    blueIcon: richTextChartBlue,
    whiteIcon: richTextChartWhite,
  },
  {
    id: 30,
    name: "treemap",
    icon: treemapChartIcon,
    blueIcon: treemapChartBlue,
    whiteIcon: treemapChartWhite,
  },
  {
    id: 31,
    name: "cluster-chart",
    icon: clusterChartIcon,
    blueIcon: clusterChartBlue,
    whiteIcon: clusterChartWhite,
  },
  {
    id: 32,
    name: "network-graph",
    icon: networkGraph,
    blueIcon: networkGraphBlue,
    whiteIcon: networkGraphWhite,
  },
];

const ChartType = ({ setShowChartSettings }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const widgetChartType = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig?.chart_type
  );
  const prolificFilters = useSelector(
    (state) => state?.apiCall?.prolificFilters
  );
  const configuration_data = useSelector(
    (state) => state.WidgetAPI.configuration_data
  );
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);

  const chartLoader = useSelector((state) => state?.WidgetAPI?.chart_loader);
  const [selectedChartName, setSelectedChartName] = useState(widgetChartType);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  // const userPrivileges = useSelector(
  //   (state) => state?.ApiCall?.brands?.data?.result?.privileges
  // );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const axisPanelAtt = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const widgetMakerGraphData = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const chartAttributesFieldConfig = useSelector(
    (state) => state?.WidgetMaker?.chart_attributes_field_config
  );
  const widgetMakerChartTypesList = useSelector(
    (state) => state.ApiCall.widget_maker_chart_type_list
  );

  useEffect(() => {
    widgetChartType && setSelectedChartName(widgetChartType);

    if (
      chartAttributesFieldConfig &&
      widgetChartType !== chartAttributesFieldConfig?.selected_chart_type
    ) {
      let updatedAxisPanelAtt = {
        ...axisPanelAtt,
        chart_type: selectedChartName,
      };
      let payloadObj = {
        authParams: authParams,
        chart_type: selectedChartName,
        axisPanelAtt: updatedAxisPanelAtt,
        chartAttributesFieldConfig: chartAttributesFieldConfig,
      };
      authParams && dispatch(getChartAttributesFieldConfigAPI(payloadObj));
    }
  }, [widgetChartType]);

  const selectedChartType = (name) => {
    setSelectedChartName(name);
    if (widgetChartType !== name) {
      dispatch(
        setWidgetChartType(
          name,
          widgetGraphConfig,
          brands,
          graphConditions,
          workspace_privileges
        )
      );
      if (name === "prolific-user") {
        let filterPanelData = getFilterPanelData(
          configuration_data[data_source]?.data,
          false
        );
        let prolific = filterPanelData?.filter((e) =>
          prolificFilters?.includes(e?.attribute)
        );
        dispatch(setFilterPanelData(prolific));
      } else {
        let filterPanelData = getFilterPanelData(
          configuration_data[data_source]?.data,
          false
        );
        dispatch(setFilterPanelData(filterPanelData));
      }
    }
  };

  const openChartSetting = () => {
    setShowChartSettings(true);
    if (widgetGraphConfig?.edit_fields) {
      dispatch(
        setY_attribute({
          ...widgetGraphConfig,
          [`edit_fields`]: {
            ...widgetGraphConfig.edit_fields,
            boolValue: false,
          },
        })
      );
    }

    dispatch(
      setChartAttributesFieldConfig({
        ...chartAttributesFieldConfig,
        open_chart_setting_flag: true,
        selected_chart_type: "card_settings",
        selected_field: chartAttributesFieldConfig?.selected_field,
        actual_field_clicked: chartAttributesFieldConfig?.actual_field_clicked,
      })
    );
    // Call KPI Chart API
    let updatedAxisPanelAtt = {
      ...widgetGraphConfig,
      // chart_attributes_field_config: {
      //   ...chartAttributesFieldConfig,
      //   open_chart_setting_flag: true,
      //   selected_chart_type: "card_settings",
      // },
    };
    let payloadObj = {
      authParams: authParams,
      chart_type: "card_settings",
      axisPanelAtt: updatedAxisPanelAtt,
      chartAttributesFieldConfig: chartAttributesFieldConfig,
    };
    authParams && dispatch(getChartAttributesFieldConfigAPI(payloadObj));
  };

  const isDarkTheme = authParams?.theme_type === "1";
  const themeClass = isDarkTheme ? "darkTheme" : "lightTheme";

  return (
    <div className={`chart-type-container ${themeClass}`}>
      <div
        className="chart-type-header"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <div className="header-left">
          <span className={`chevron-icon ${isCollapsed ? "collapsed" : ""}`}>
            ▼
          </span>
          <span className="header-title">Chart</span>
        </div>
        <div className="header-right">
          <span
            className="blue-text cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              openChartSetting();
            }}
          >
            Chart Settings
          </span>
        </div>
      </div>
      <div
        className={`chart-type-content ${
          isCollapsed ? "collapsed" : ""
        } ${themeClass}`}
      >
        <div
          className={`d-flex flex-wrap justify-content-start chartTypeList ${
            chartLoader && "disable"
          }`}
        >
          {chartType?.map((chart, i) => {
            if (
              workspace_privileges?.unsupported_chart_types &&
              Array.isArray(workspace_privileges?.unsupported_chart_types) &&
              workspace_privileges?.unsupported_chart_types?.includes(
                chart?.name
              )
            ) {
              return "";
            }
            if (widgetMakerChartTypesList?.includes(chart?.name))
              return (
                <Tooltip
                  title={
                    chart.name === "kpi" ? (
                      chart.name.toUpperCase()
                    ) : (
                      <div className="text-transform__capitalize">
                        {chart.name.charAt(0).toUpperCase() +
                          chart.name.slice(1).split("-").join(" ")}
                      </div>
                    )
                  }
                  placement="top"
                >
                  <div
                    className={`cursor-pointer border-radius-4 p-2 border ${
                      window.location.pathname === "/dashboard" &&
                      (chart.name === "network-graph" ||
                        chart.name === "network-graph-v2")
                        ? "disable"
                        : ""
                    } ${
                      selectedChartName === chart.name
                        ? "border-blue"
                        : "border-color"
                    } mr-2 mb-2`}
                    onClick={() => selectedChartType(chart.name)}
                    key={i}
                  >
                    <img
                      src={
                        selectedChartName === chart.name
                          ? chart.blueIcon
                          : authParams?.theme_type === "1"
                          ? chart.whiteIcon
                          : chart.icon
                      }
                      style={{ maxWidth: "2.1rem" }}
                      alt="chart icon"
                    />
                  </div>
                </Tooltip>
              );
          })}
        </div>
      </div>
    </div>
  );
};

export default ChartType;
